import styled, { css, keyframes } from 'styled-components';
import { select } from '../../core/themev2';

const Container = styled.div`
  width: 100%;
  height: ${({ device }) => (device !== 'tablet' ? '86px' : '119px')};
  border-radius: 8px;
  border: 1px solid
    ${({ isLoading, device }) => {
      if (isLoading && device !== 'mobile') return select('middleGray');
      if (device === 'mobile') return select('transparent');
      return select('midLightGray');
    }};
  display: flex;
  justify-content: ${({ device }) => (device === 'desktop' ? 'space-between' : 'flex-start')};
  overflow: hidden;
  font-family: Hind;
  font-style: normal;
  .img-container {
    position: relative;
  }
  .img-frame {
    width: ${({ device }) => (device !== 'tablet' ? '84px' : '165px')};
    height: ${({ device }) => (device !== 'tablet' ? '86px' : '119px')};
    display: flex;
    justify-content: center;
    background-color: ${select('middleGray')};
  }
  img {
    width: ${({ hasImage, device }) => {
      if (hasImage && device === 'tablet') return '165px';
      if (hasImage) return '84px';
      if (!hasImage && device === 'tablet') return '101px';
      return '69px';
    }};
    height: ${({ hasImage, device }) => {
      if (hasImage && device === 'tablet') return '119px';
      if (hasImage) return '86px';
      return 'auto';
    }};
    object-fit: ${({ hasImage }) => (hasImage ? 'cover' : 'contain')};
    border-radius: ${({ device }) => (device !== 'mobile' ? 'none' : '8px')};
  }
  .tag-reserved {
    font-size: 12px;
    font-weight: 500;
    line-height: normal;
    width: 71px;
    height: 19px;
    border-radius: 8px;
    text-align: center;
    background-color: ${select('negative')};
    color: ${select('white')};
    position: absolute;
    left: calc(50% - 71px / 2);
    top: 7px;
  }
  .info-container {
    width: ${({ device }) => {
      if (device === 'desktop') return '206px';
      if (device === 'mobile') return '79%';
      return '88%';
    }};
    padding: 12px 15px 13px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${({ device }) => (device !== 'tablet' ? '0px' : '8px')};
    overflow: hidden;
  }
  .realestateType {
    font-size: ${({ device }) => (device !== 'tablet' ? '12px' : '14px')};
    font-weight: 500;
    line-height: normal;
    color: ${select('darkGray')};
  }
  .title {
    font-size: ${({ device }) => (device !== 'tablet' ? '14px' : '18px')};
    font-weight: 600;
    line-height: 130%;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .address {
    font-size: ${({ device }) => (device !== 'tablet' ? '12px' : '16px')};
    font-weight: 500;
    line-height: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    color: ${select('midDarkGray')};
  }
`;

const BackgroundGradient = css`
  background: linear-gradient(
    90deg,
    #e7eef0 0%,
    #f3f7f8 23.66%,
    rgba(250, 251, 252, 0.489237) 45.78%,
    #f2f6f7 78.19%,
    #e7eef0 98.76%
  );
`;

const ShineLines = keyframes`
  0% { background-position: -200px };
  100% { background-position: 350px};
`;

export const animationLine = css`
  animation: ${ShineLines} 4s infinite linear;
`;

const SkeletonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 15px;
`;

const InfoSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: ${({ device }) => (device !== 'tablet' ? '5px' : '10px')};
  margin-right: 15px;
`;

const LineContent = styled.div`
  height: ${({ height }) => height || '16px'};
  width: ${({ width }) => width || '100%'};
  border-radius: ${({ borderRadius }) => borderRadius || '8px'};
  ${BackgroundGradient};
  ${animationLine};
`;

export { Container, InfoSkeleton, LineContent, SkeletonContainer };
